// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preview-file-dialog__container {
    position: relative;
}

.preview-file-dialog__menu {
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%);
    text-align: center;
    background-color: white;
    box-shadow: 0px 2px 7px 1px rgba(0,0,0,0.75);
    border-radius: 3px;
    padding: 1rem;
    z-index: 1000;
}

.preview-file-dialog__menu.image {
    min-width: 20rem;
    min-height: 20rem;
    z-index: 1000;
    padding: 2rem;
}

.preview-file-dialog__menu.file {
    min-width: 20rem;
    min-height: 8rem;
    padding: 2rem;
}

.previewFileDialog__image {
    max-width: 100%;
    max-height: 100%;
}

.previewFileDialog__image img {
    max-width: 90%;
    min-height: 5rem;
    max-height: 13.5rem;
    box-shadow: 0px 0px 2px 2px rgba(0,0,0,0.1);
}

.previewFileDialog__file-name {
    font-size: medium;
    font-weight: bold;
}

.previewFileDialog__footer {
    padding: 2rem 0 0;
    display: flex;
    justify-content: space-between;
    gap: 2rem;
}

.preview-file-dialog__cancel_button {
    background-color: #d22e37;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/preview-file-dialog/PreviewFileDialog.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;IAChC,kBAAkB;IAClB,uBAAuB;IACvB,4CAA4C;IAC5C,kBAAkB;IAClB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".preview-file-dialog__container {\r\n    position: relative;\r\n}\r\n\r\n.preview-file-dialog__menu {\r\n    position: fixed !important;\r\n    top: 50% !important;\r\n    left: 50% !important;\r\n    transform: translate(-50%, -50%);\r\n    text-align: center;\r\n    background-color: white;\r\n    box-shadow: 0px 2px 7px 1px rgba(0,0,0,0.75);\r\n    border-radius: 3px;\r\n    padding: 1rem;\r\n    z-index: 1000;\r\n}\r\n\r\n.preview-file-dialog__menu.image {\r\n    min-width: 20rem;\r\n    min-height: 20rem;\r\n    z-index: 1000;\r\n    padding: 2rem;\r\n}\r\n\r\n.preview-file-dialog__menu.file {\r\n    min-width: 20rem;\r\n    min-height: 8rem;\r\n    padding: 2rem;\r\n}\r\n\r\n.previewFileDialog__image {\r\n    max-width: 100%;\r\n    max-height: 100%;\r\n}\r\n\r\n.previewFileDialog__image img {\r\n    max-width: 90%;\r\n    min-height: 5rem;\r\n    max-height: 13.5rem;\r\n    box-shadow: 0px 0px 2px 2px rgba(0,0,0,0.1);\r\n}\r\n\r\n.previewFileDialog__file-name {\r\n    font-size: medium;\r\n    font-weight: bold;\r\n}\r\n\r\n.previewFileDialog__footer {\r\n    padding: 2rem 0 0;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    gap: 2rem;\r\n}\r\n\r\n.preview-file-dialog__cancel_button {\r\n    background-color: #d22e37;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
